module.exports = __webpack_public_path__ + "static/media/inktoberSpider.df5a3f51.gif";